<template>
  <div>
    <!-- breadcrumb start -->
    <breadcrumb-shop 
      banner_height="page-banner-height-2" 
      title="Product Details" 
      subtitle="Product Details">
    </breadcrumb-shop>
    <!-- breadcrumb end -->
  
    <!-- shop details area start -->
    <shop-details-top :product="product"></shop-details-top>
    <shop-details-desc :product="product"></shop-details-desc>
    <!-- shop details area end -->
  
    <!-- cta area start -->
    <cta-area></cta-area>
    <!-- cta area end -->
  </div>
</template>

<script>
import CtaArea from '@/components/cta/cta-area.vue';
import BreadcrumbShop from '@/components/breadcrumb/breadcrumb-shop.vue';
import ShopDetailsTop from '@/components/shop/details/shop-details-top.vue';
import ShopDetailsDesc from '@/components/shop/details/shop-details-desc.vue';

export default {
  name: 'ShopDetails',
  components: {
    CtaArea,
    BreadcrumbShop,
    ShopDetailsTop,
    ShopDetailsDesc
  },
  data() {
    return {
      product: {}, // Initialize product as an empty object
    };
  },
  methods: {
    // Fetch product details using the API
    async getProductDetails(productId) {
      try {
        const response = await this.$axios.get(`product/${productId}/details`); // Update with your Laravel API route
        this.product = response.data; // Assign the API response data to `product`
      } catch (error) {
        console.error('Error fetching product details:', error);
      }
    },
  },
  mounted() {
    const productId = this.$route.params.id; // Get product ID from route parameters
    this.getProductDetails(productId); // Fetch product details
  },
};
</script>

<style scoped>
/* Add any required styling here */
</style>
